/**
 * SectionIcons — v2 상세 섹션 제목 아이콘 (인라인 SVG, 20px).
 * 목업은 Material Symbols 폰트를 쓰지만 코드 정책(이모지·아이콘폰트 미사용, SVG only)에 따라
 * 같은 의미의 선 아이콘으로 대체한다 (계획서 3장 H).
 */

import React from 'react';

const base = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/** redeem — 혜택안내 */
export const GiftIcon = () => (
  <svg {...base}>
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
  </svg>
);
/** table_chart — 타입별 분양가 */
export const TableIcon = () => (
  <svg {...base}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 10h18M9 10v10" />
  </svg>
);
/** architecture — 평면도 */
export const PlanIcon = () => (
  <svg {...base}>
    <rect x="3" y="3" width="18" height="18" rx="1.5" />
    <path d="M3 12h7M14 3v6M14 13v8M10 12v4" />
  </svg>
);
/** event — 청약일정 */
export const CalendarIcon = () => (
  <svg {...base}>
    <rect x="3" y="4.5" width="18" height="16.5" rx="2" />
    <path d="M16 2.5v4M8 2.5v4M3 10h18" />
  </svg>
);
/** trending_up — 실거래 비교 */
export const TrendIcon = () => (
  <svg {...base}>
    <polyline points="3 17 9 11 13 15 21 7" />
    <polyline points="15 7 21 7 21 13" />
  </svg>
);
/** location_city — 입지 */
export const CityIcon = () => (
  <svg {...base}>
    <path d="M3 21h18M5 21V8l6-4v17M11 21V10h8v11" />
    <path d="M14 13h2M14 17h2M7 11h1M7 15h1" />
  </svg>
);
/** store — 모델하우스 */
export const StoreIcon = () => (
  <svg {...base}>
    <path d="M3 9l1.5-5h15L21 9" />
    <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
    <path d="M5 11.5V21h14v-9.5M10 21v-5h4v5" />
  </svg>
);
/** compare_arrows — 인근 단지 */
export const CompareIcon = () => (
  <svg {...base}>
    <path d="M7 7h13M16 3l4 4-4 4M17 17H4M8 13l-4 4 4 4" />
  </svg>
);
/** info — 단지 정보 */
export const InfoIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </svg>
);
/** 입지 카드 아이콘 — 교통/학군/생활/호재 */
export const TrainIcon = () => (
  <svg {...base}>
    <rect x="5" y="3" width="14" height="14" rx="3" />
    <path d="M5 11h14M9 21l-2-4M15 21l2-4M9 14h.01M15 14h.01" />
  </svg>
);
export const SchoolIcon = () => (
  <svg {...base}>
    <path d="M22 10L12 5 2 10l10 5 10-5z" />
    <path d="M6 12v5c0 1 3 2.5 6 2.5s6-1.5 6-2.5v-5" />
  </svg>
);
export const BagIcon = () => (
  <svg {...base}>
    <path d="M6 7h12l1 14H5L6 7z" />
    <path d="M9 7V5a3 3 0 0 1 6 0v2" />
  </svg>
);
export const LandmarkIcon = () => (
  <svg {...base}>
    <path d="M3 21h18M4 10h16M12 3l8 5H4l8-5zM6 10v8M10 10v8M14 10v8M18 10v8" />
  </svg>
);
